// extracted by mini-css-extract-plugin
export default {"productDescription":"Haa-z","featuredDescription":"Iaa-z","description":"Jaa-z","more":"Kaa-z","descriptionSku":"Laa-z"};